import React, { useContext, useState, useEffect } from "react";
import { ListItemSecondaryAction, Grid } from "@mui/material";
import MainCard from "ui-component/cards/MainCard";
import Steeper from "components/Steps/Steeper";
import {
  stepsSolicitudCredito,
  procesoOK,
  procesoWarning,
  procesoError,
} from "utils/Constantes";
import Table from "components/Tabla/Table";
import endpoints from "utils/services/EndPoints";
import Api from "utils/services/Api";
import { decimalFormat, localdatetime } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Button from "@mui/material/Button";
import { getCodigoUsuario, getCodigoIfip } from "utils/Common";
import { usePersona } from "../../context/persona";
import FeatherIcon from "feather-icons-react";
//import LectorPdf from 'components/Pdf/LectorPdf';
const TablaAmortizacion = () => {
  const { infoPersona, setInfoPersona } = usePersona();
  const navigate = useNavigate();
  // HOOKS DE ESTADO NOTIFICACIONES
  const [openNotificacion, setOpenNotificacion] = useState(false);
  const [visualizaMensaje, setVisualizaMensaje] = useState("");
  const [colorNotificacion, setColorNotificacion] = useState("");

  const [openPoput, setOpenPoput] = useState(false);

  // HOOKS COMUN
  const operacionCredito = infoPersona.codigo;
  // ACCESOS STEPS
  const [stepsActive, setStepsActive] = useState(0);
  const [listTablaAmortizacion, setListTablaAmortizacion] = useState([]);

  let fechaActual;
  // USEEFECT
  useEffect(() => {
    if (infoPersona.codigo === "" || infoPersona === undefined) {
      navigate("/home/solicitudCredito");
    } else {
      init();
    }
  }, []);
  // FUNCIONES NOTIFICACION
  const generarNotificacion = (abrir, mensaje, color) => {
    setOpenNotificacion(abrir);
    setVisualizaMensaje(mensaje);
    if (color === 1) {
      setColorNotificacion(procesoOK);
    }
    if (color === 2) {
      setColorNotificacion(procesoWarning);
    }
    if (color === 3) {
      setColorNotificacion(procesoError);
    }
  };
  const cerrarNotificacion = () => {
    setOpenNotificacion(false);
  };
  //FUNCIONES NEGOCIO
  const init = () => {
    setStepsActive(2);
    handleSearchTablaAmortizacion();
    // fechaActual = moment(Date.now()).format('YYYY-MM-DD');
  };
  const nextStep = () => {
    navigate("/home/flujos");
  };
  const backStep = () => {
    navigate("/home/solicitudCredito");
  };
  const handleSearchTablaAmortizacion = () => {
    let fechaPago = localdatetime(moment().add(30, "day"));
    if (infoPersona.row.fechaPago){
      fechaPago = localdatetime(infoPersona.row.fechaPago);
    }
    try {
      (async () => {
        const requestTablaAmortizacion = {
          pin_monto_credito: 0, // TOMA DE TABLA DE OPERACION CREDITICIA
          pin_tasa_interes: 0, // TOMA DE TABLA DE OPERACION CREDITICIA
          pin_dias_periodicidad: 0, // TOMA DE TABLA DE OPERACION CREDITICIA
          pin_numero_cuota: 0, // TOMA DE TABLA DE OPERACION CREDITICIA
          pid_fecha_pago: fechaPago,// "2024-06-11",//localdatetime(Date.now()), // "2022-12-25"
          piv_tipo_calculo: "", // TOMA DE TABLA DE OPERACION CREDITICIA
          pin_periodo_gracia: 0,
          numeroOperacionCredito: operacionCredito,
          codigoUsuarioRegistro: getCodigoUsuario(),
        };
        Api(
          endpoints.obtieneTablaAmortizacion,
          "POST",
          requestTablaAmortizacion
        )
          .then((response) => {
            if (response.codigo === 0) {
              generarNotificacion(
                true,
                "Error al generar tabla de amortización",
                3
              );
              return;
            } else {
              setInfoPersona({ row: infoPersona.row, codigo: operacionCredito, codigoPersona: infoPersona.codigoPersona, valorSolicitado: infoPersona.valorSolicitado, primeraCuota: response[0].valor_cuota });
              console.log("Datos de tabla de amortizacion");
              console.log(response);
              setListTablaAmortizacion(response);
              generarNotificacion(
                true,
                "Tabla de amortización generada con éxito.",
                1
              );
            }
          })
          .catch((error) => {
            generarNotificacion(true, error.mensaje, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.mensaje, 3);
    }
  };
  // VALIDACIONES
  // VISTA
  const columns = [
    {
      field: "numero_cuota",
      title: "Número cuota",
      width: 90,
      editable: 'never'
    },
    {
      field: "fecha_inicio_pago",
      //render: (rowData) => <p>{rowData.fecha_inicio_pago.year+"-"+rowData.fecha_inicio_pago.monthValue+"-"+rowData.fecha_inicio_pago.dayOfMonth}</p>,
      //render: (rowData) => <p>{localdatetime(rowData.fecha_inicio_pago)}</p>,
      title: "Fecha inicio pago",
      width: 150,
      editable: 'never'
    },
    {
      field: "fecha_fin_pago",
      //render: (rowData) => <p>{rowData.fecha_fin_pago.year+"-"+rowData.fecha_fin_pago.monthValue+"-"+rowData.fecha_fin_pago.dayOfMonth}</p>,
      title: "Fecha fin pago",
      width: 150,
      editable: 'never'
    },
    {
      field: "saldo_vigente",
      render: (rowData) => <p>{decimalFormat(rowData.saldo_vigente)}</p>,
      editable: 'never',
      title: "Saldo vigente",
      width: 150,
    },
    {
      field: "valor_capital",
      render: (rowData) => <p>{decimalFormat(rowData.valor_capital)}</p>,

      title: "Valor capital",
      width: 150,
      editable: 'never'
    },
    {
      field: "valor_interes",
      render: (rowData) => <p>{decimalFormat(rowData.valor_interes)}</p>,

      title: "Valor Interes",
      type: "number",
      width: 110,
      editable: 'never'
    },
    {
      field: "valor_cuota",
      render: (rowData) => <p>{decimalFormat(rowData.valor_cuota)}</p>,

      title: "Valor Cuota",
      type: "number",
      width: 110,
      editable: 'never'
    },
  ];
  // GENERAR PDF
  const visualizarPdf = () => {
    setOpenPoput(true);
  };
  return (
    <>
      <Steeper steps={stepsSolicitudCredito} activeStep={stepsActive} />
      <MainCard
        title="TABLA AMORTIZACIÓN"
        open={openNotificacion}
        mensajeVizualizar={visualizaMensaje}
        colorProceso={colorNotificacion}
        handleClose={() => cerrarNotificacion()}
        secondary={
          <ListItemSecondaryAction link="https://next.material-ui.com/system/typography/" />
        }
      >
        <Grid container xs={12}>
          <Grid item xs={12}>
            <Table
              title="Tabla amortización"
              columns={columns}
              editable={false}
              data={listTablaAmortizacion}
              paging={false}
            ></Table>
            {/** {openPoput && (
                            <LectorPdf
                                activaPopup = {openPoput}
                                columns={columns}
                                data={listTablaAmortizacion}
                            />
                        )}*/}
          </Grid>
        </Grid>
        <div className="steps-action">
          <Button
            type="primary"
            block
            htmlType="submit"
            loading={true}
            onClick={nextStep}
          >
            <FeatherIcon icon="chevrons-right" size={16} /> &nbsp; Siguiente
          </Button>
          <Button
            type="primary"
            block
            htmlType="submit"
            loading={true}
            onClick={backStep}

          >
            <FeatherIcon icon="x-circle" size={16} /> &nbsp; Cancelar
          </Button>
        </div>
      </MainCard>
    </>
  );
};
export default TablaAmortizacion;
